import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUser } from '@bca-shared/models/user';
import { Gender } from '@bca-shared/models/_enums';
@Pipe({ name: 'displayName' })
export class DisplayNamePipe implements PipeTransform {
    constructor(private _translate: TranslateService) { }

    transform(user: IUser): Observable<string> {
        if (!user) return EMPTY;

        const { gender, initials, middleName, lastName } = user;
        let translateKey: string;

        switch (gender) {
            case Gender.MALE:
                translateKey = 'INPUT.MALE';
                break;
            case Gender.FEMALE:
                translateKey = 'INPUT.FEMALE';
                break;
            case Gender.NOT_RELEVANT:
                translateKey = null;
                break;
        }

        return this.createDisplayCollectionName(translateKey, user)
    }

    private createDisplayCollectionName(translateKey: null | string, user: IUser): Observable<string> {
        const displayNameCollection = [
            user.initials,
            user.middleName,
            user.lastName
        ].filter(value => value != null);

        if (translateKey !== null && translateKey !== undefined) {
            return this._translate.get(translateKey).pipe(
                map((preamble: string) => {
                    displayNameCollection.unshift(preamble);

                    return displayNameCollection.length >= 3
                        ? displayNameCollection.join(' ')
                        : null;
                })
            );
        } else {

            // in case of gender neutral, translation of empty preamble is prevented but displayNameCollection needs to be of type Observable
            return of(displayNameCollection.length >= 2
                ? displayNameCollection.join(' ')
                : null);
        }

    }
}
